var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.63L9.71 1.29a1.004 1.004 0 00-1.42 1.42L22 16.45 8.29 30.19a1 1 0 000 1.41 1 1 0 00.71.29 1 1 0 00.71-.29L24 17.26a1 1 0 00.28-.81 1 1 0 00-.28-.82z"
  })));
}

export default SvgNext;